/* eslint-env browser */
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import transitions from '../transitions';

const contentStyle = {
  container: {
    overflow: 'hidden',
    backgroundColor: colors.designSystem.grey10,
    height: '100%',
  },
  content: {
    position: 'relative',
    height: '100%',
    top: 0,
    ...transitions.inboxExpansion,
  },
};

export default contentStyle;
